<template>
    <div>
        <kgr-empty
            v-if="offerings.length === 0"
            :value="$t('offering.noResults')"
        />

        <div v-else>
            <kgr-offering-table
                :club-id="clubId"
                :offerings="offerings"
                :filter="filter"
            />
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import KgrOfferingTable from './OfferingTable';

export default {
    name: 'KgrOfferingList',
    components: {
        'kgr-offering-table': KgrOfferingTable,
        'kgr-empty': EmptyData,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offerings: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>
